import React, { useEffect, useState } from "react";
import { Modal, Box, Grid, Button, Select, MenuItem } from "@mui/material";
import { Api_Token } from "../../util/Api";
import { useTranslation } from "react-i18next"; // Assuming you are using `react-i18next`
import TitreGraphik from "../Typography/TitreGraphik";
import LabelTypography from "../Typography/LabelTypography";
import NumericFormatEnv from "../Numeric/NumericFormatEnv";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "white",
  boxShadow: 24,
  p: 4,
};

function ModelCaisseNotAvailable({ open, onClose }) {
  const { t } = useTranslation();
  const [store, setStore] = useState([]);
  const [selectedCaisse, setSelectedCaisse] = useState("");
  const [loading, setLoading] = useState(false);
  const [CaisseInfo, setCaisseInfo] = useState();
  const [Idcaisse, setIdCaisse] = useState();

  useEffect(() => {
    if (open) {
      setLoading(true);
      Api_Token.get(`caisses/getNotAvailableCaisses`)
        .then((response) => {
          setStore(response.data);
        })
        .catch((error) => {
          console.error("Error fetching caisses:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [open]);

  const handleSubmit = () => {
    if (!selectedCaisse) {
      alert(t("Please select a caisse before closing!"));
      return;
    }

    Api_Token.post(`CaisseJourney/closeCaisseWithStore/${selectedCaisse}`)
      .then(() => {
        //alert(t("Caisse closed successfully!"));
        onClose();
      })
      .catch((error) => {
        console.error("Error closing caisse:", error);
        alert(t("Failed to close the caisse."));
      });
  };

  useEffect(() => {
    const fetchCaisseInfo = async () => {
      setLoading(true);
      try {
        const response = await Api_Token.get(
          `CaisseJourney/getOneByIdCaisse/${selectedCaisse}`
        );
        setCaisseInfo(response.data);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
      setLoading(false);
    };
    if (selectedCaisse) {
      fetchCaisseInfo();
    }
  }, [selectedCaisse]);

  async function Export() {
    try {
      setLoading(true);
      const response = await Api_Token.get(
        `/transaction/getTransactionByCaisseJournyExcel/${selectedCaisse}`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "transactions.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting transactions:", error);
    }
    setLoading(false);
  }

  function Close() {
    setSelectedCaisse();
    setCaisseInfo();
    onClose();
  }

  return (
    <Modal open={open} onClose={Close}>
      <Box sx={modalStyle}>
        <Box sx={{ textAlign: "center" }}>
          <TitreGraphik>Close Caisse</TitreGraphik>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Select
              required
              name="store"
              fullWidth
              value={selectedCaisse}
              onChange={(e) => setSelectedCaisse(e.target.value)}
            >
              {store.map((s) => (
                <MenuItem key={s.id} value={s.id}>
                  {s.nomCaisse}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          {selectedCaisse && (
            <>
              <Grid item xs={12}>
                <LabelTypography>
                  <b>{t("Montant Depart : ")}</b>{" "}
                  <NumericFormatEnv Number={CaisseInfo?.montantDepart} />
                </LabelTypography>
              </Grid>
              <Grid item xs={12}>
                <LabelTypography>
                  <b>{t("montant now : ")}</b>
                  <NumericFormatEnv Number={CaisseInfo?.montantNow} />
                </LabelTypography>
              </Grid>
              <Grid item xs={12}>
                <LabelTypography>
                  <b>{t("montant cash : ")}</b>
                  <NumericFormatEnv Number={CaisseInfo?.totalCash} />
                </LabelTypography>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" color="error" onClick={Close}>
                  {t("Cancel")}
                </Button>
              </Grid>
              {selectedCaisse && (
                <Grid item>
                  <Button variant="outlined" color="success" onClick={Export}>
                    {t("export")}
                  </Button>
                </Grid>
              )}
              <Grid item>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                  disabled={loading}
                >
                  {t("Close")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default ModelCaisseNotAvailable;
